var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgressCircleGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM3.6 12C3.6 16.6392 7.36081 20.4 12 20.4C16.6392 20.4 20.4 16.6392 20.4 12C20.4 7.36081 16.6392 3.6 12 3.6C7.36081 3.6 3.6 7.36081 3.6 12Z",
    fill: "#E4F1EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C14.3734 2.83022e-08 16.6935 0.703788 18.6668 2.02236C20.6402 3.34094 22.1783 5.21509 23.0866 7.4078C23.9948 9.60051 24.2324 12.0133 23.7694 14.3411C23.3064 16.6689 22.1635 18.8071 20.4853 20.4853L17.9397 17.9397C19.1145 16.7649 19.9145 15.2682 20.2386 13.6388C20.5627 12.0093 20.3964 10.3204 19.7606 8.78546C19.1248 7.25056 18.0482 5.93866 16.6668 5.01566C15.2854 4.09265 13.6614 3.6 12 3.6V0Z",
    fill: "#78BB96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressCircleGreen);
export default __webpack_public_path__ + "static/media/in-progress-circle-green.b9ec041b8e90e131e801f9072c408f69.svg";
export { ForwardRef as ReactComponent };